import React, { Component } from "react";

class Tab extends Component {
    constructor(props) {
        super(props);

        this._onPress = this._onPress.bind(this);
    }

    _onPress() {
        const { url, onClick } = this.props;

        if (onClick) onClick(url);
    }

    render() {
        const { style, title, url, current } = this.props;

        return (
            <div className={style} onClick={this._onPress}>
                <div
                    className={
                        current === url
                            ? "transition cursor-pointer flex flex-col h-full items-center justify-center border-b-4 border-blue text-blue"
                            : "transition cursor-pointer flex flex-col h-full items-center justify-center text-black text-opacity-20 hover-hover:hover:text-blue border-b-4 border-black border-opacity-20 hover-hover:hover:border-blue"
                    }
                >
                    <p className="font-judge font-bold text-30 uppercase">
                        {title}
                    </p>
                </div>
            </div>
        );
    }
}

Tab.defaultProps = {
    style: "mr-30 xl:mr-40",
};

export default Tab;
